const updates = [
  {
    date: '2024.07.28',
    title: '《异界触手录》第128话更新',
    desc: '热门触手漫画异界触手录最新话已上线，主角觉醒新能力，精彩剧情不容错过。',
    type: 'update',
  },
  {
    date: '2024.07.27',
    title: '《触手都市》第95话更新',
    desc: '都市奇幻触手漫画触手都市新章节已发布，揭开隐藏在城市深处的秘密。',
    type: 'update',
  },
  {
    date: '2024.07.26',
    title: '《触手纪元》第73话更新',
    desc: '科幻机甲触手漫画触手纪元最新话上线，机甲与触手科技的终极对决拉开帷幕。',
    type: 'update',
  },
  {
    date: '2024.07.25',
    title: '新作《深海触手》上架',
    desc: '全新触手漫画深海触手正式上架，讲述深海世界中人类与触手生物的奇幻冒险故事。',
    type: 'new',
  },
  {
    date: '2024.07.24',
    title: '《暗夜触手》第56话更新',
    desc: '悬疑惊悚触手漫画暗夜触手更新，校园中的触手之谜逐渐浮出水面。',
    type: 'update',
  },
  {
    date: '2024.07.23',
    title: '《触手学园》第112话更新',
    desc: '校园搞笑触手漫画触手学园更新，触手伙伴们的搞笑日常再次上演。',
    type: 'update',
  },
  {
    date: '2024.07.22',
    title: '《触手物语》第88话更新',
    desc: '温馨日常触手漫画触手物语新章节发布，少女与触手生物的温暖故事继续。',
    type: 'update',
  },
  {
    date: '2024.07.21',
    title: '触手漫画专题「夏日特辑」上线',
    desc: '触手漫画夏日特别专题正式推出，精选夏日主题触手漫画合集，陪你度过清凉一夏。',
    type: 'event',
  },
];

const typeConfig: Record<string, { bg: string; text: string }> = {
  update: { bg: 'bg-primary-100', text: 'text-primary-600' },
  new: { bg: 'bg-accent-100', text: 'text-accent-600' },
  event: { bg: 'bg-secondary-100', text: 'text-secondary-600' },
};

const typeLabel: Record<string, string> = {
  update: '更新',
  new: '新作',
  event: '活动',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          更新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画最新更新与动态速递
        </p>
        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-5 pl-10 md:pl-12">
                <div
                  className={`absolute left-2 md:left-2.5 top-1.5 w-4 h-4 rounded-full border-2 border-background-50 ${
                    typeConfig[item.type].bg
                  }`}
                ></div>
                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.date}
                    </span>
                    <span
                      className={`px-2 py-0.5 text-xs rounded-full whitespace-nowrap ${typeConfig[item.type].bg} ${typeConfig[item.type].text}`}
                    >
                      {typeLabel[item.type]}
                    </span>
                  </div>
                  <h4 className="text-sm font-heading font-bold text-foreground-800 mb-1">
                    {item.title}
                  </h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}